<div [innerHTML]="state.displayVal"></div>
